// The picker's categories, which search.ts filters and counts by.  Edited by
// hand: which MDI categories each shelf shows, and which icons it adds.

export interface IconShelf {
  name: string;
  // MDI categories; an icon is on the shelf when it has any of them.
  tags: string[];
  // Icons we put on the shelf by hand, because MDI gave them no category,
  // only ones no shelf shows (book has none; lightbulb is only in Home
  // Automation), or ones that put them elsewhere (brain is Medical).  An icon
  // can be on several shelves.  3.5.95 names, from mdi-3.5.95-search.json.
  extraIcons?: string[];
}

/**
 * The picker's categories, most useful for cogs first.  MDI's 60 categories
 * are built for app developers, so these group the ones teachers browse and
 * leave out the rest (Battery, Database, Tooltip, Arrow, ...), whose words
 * still match a typed query.
 */
export const iconShelves: IconShelf[] = [
  {
    name: 'Learning & Ideas',
    tags: [],
    extraIcons: [
      'brain',
      'bullseye',
      'bullseye-arrow',
      'certificate',
      'chart-line',
      'check-circle',
      'chess-knight',
      'clipboard-check',
      'compass',
      'compass-outline',
      'flag-checkered',
      'help-circle',
      'help-circle-outline',
      'lead-pencil',
      'lightbulb',
      'lightbulb-on',
      'lightbulb-on-outline',
      'lightbulb-outline',
      'magnify',
      'medal',
      'notebook',
      'pencil',
      'presentation',
      'presentation-play',
      'progress-check',
      'puzzle',
      'puzzle-outline',
      'ribbon',
      'rocket',
      'school',
      'stairs',
      'target',
      'target-variant',
      'teach',
      'thought-bubble',
      'thought-bubble-outline',
      'trending-up',
      'trophy',
      'trophy-award',
      'trophy-outline'
    ]
  },
  {
    name: 'People & Feelings',
    tags: ['Account / User', 'People / Family', 'Emoji'],
    extraIcons: [
      'chat',
      'comment',
      'comment-multiple',
      'comment-multiple-outline',
      'comment-outline',
      'comment-question',
      'comment-question-outline',
      'forum',
      'forum-outline',
      'hand-okay',
      'hand-peace',
      'heart-broken',
      'heart-multiple',
      'message',
      'message-outline',
      'message-text',
      'message-text-outline',
      'thumb-down',
      'thumb-down-outline',
      'thumb-up',
      'thumb-up-outline',
      'thumbs-up-down'
    ]
  },
  { name: 'Science & Math', tags: ['Science', 'Math'] },
  {
    name: 'Nature & Animals',
    tags: ['Nature', 'Animal', 'Weather', 'Agriculture'],
    extraIcons: ['recycle']
  },
  { name: 'Sports & Games', tags: ['Sport', 'Gaming / RPG'] },
  {
    name: 'Arts & Music',
    tags: ['Drawing / Art', 'Music', 'Photography', 'Video / Movie', 'Color']
  },
  {
    name: 'Reading & Writing',
    tags: ['Text / Content / Format', 'Files / Folders', 'Edit / Modify'],
    extraIcons: [
      'book',
      'book-multiple',
      'book-open',
      'book-open-outline',
      'book-open-page-variant',
      'book-outline',
      'book-variant',
      'bookmark',
      'bookmark-outline',
      'clipboard-check',
      'clipboard-check-outline',
      'clipboard-text',
      'clipboard-text-outline',
      'library-shelves',
      'notebook'
    ]
  },
  {
    name: 'Places & Travel',
    tags: [
      'Places',
      'Navigation',
      'Transportation + Flying',
      'Transportation + Other',
      'Transportation + Road',
      'Transportation + Water',
      'Automotive'
    ],
    extraIcons: ['home-city', 'home-modern', 'home-variant', 'tent']
  },
  { name: 'Food', tags: ['Food / Drink'] },
  { name: 'Health', tags: ['Medical / Hospital', 'Health / Beauty'] },
  { name: 'Time & Holidays', tags: ['Date / Time', 'Holiday'] },
  { name: 'Money & Shopping', tags: ['Banking', 'Currency', 'Shopping'] },
  {
    name: 'Tech & Tools',
    tags: ['Device / Tech', 'Developer / Languages', 'Hardware / Tools'],
    extraIcons: ['keyboard', 'robot']
  },
  {
    name: 'Shapes & Symbols',
    tags: ['Shape', 'Religion'],
    extraIcons: [
      'crown',
      'diamond',
      'diamond-outline',
      'fire',
      'flag',
      'flag-outline',
      'flag-triangle',
      'flag-variant',
      'flag-variant-outline',
      'star-box',
      'star-box-outline'
    ]
  }
];
